// src/auth/RequireAuth.js
// Wraps a route. If the user is not signed in, sends them to /login.
// While we're still figuring out whether they have a session
// (just after page reload), we render a tiny loading state.

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "grid",
          placeItems: "center",
          color: "var(--ink-3)",
          fontSize: 14,
        }}
      >
        Checking your session…
      </div>
    );
  }

  if (!user) {
    // After login we send the user back where they were trying to go.
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}